var _polygon, _polygon2, _polygon3, _polygon4, _polygon5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVadeMecumLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 209.35 89.56",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "48.67 0 63.22 53.57 77.78 0 48.67 0 48.67 0 48.67 0"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "82.9 89.56 112.01 89.56 136.34 0 107.23 0 82.9 89.56"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.44 89.56 24.33 89.56 0 0 29.11 0 53.44 89.56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "131.57 89.56 160.68 89.56 185.01 0 155.9 0 131.57 89.56"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "180.24 89.56 194.8 35.99 209.35 89.56 180.24 89.56 180.24 89.56 180.24 89.56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVadeMecumLogo);
export default __webpack_public_path__ + "static/media/VadeMecumLogo.215ff3abe767b0b2f419506259e6d9eb.svg";
export { ForwardRef as ReactComponent };